import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fixed inset-0 z-20 flex flex-col bg-white p-5 md:p-10",
  role: "dialog"
}
const _hoisted_2 = { class: "container flex h-full flex-col overflow-y-auto text-xl md:text-2xl" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "flex flex-auto flex-col items-center justify-center space-y-15" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShareModal && _ctx.toggleShareModal(...args))),
          class: "ml-auto"
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.closeModalLabel), 1),
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            width: "38",
            height: "38",
            focusable: "false",
            "aria-hidden": "true",
            class: "mr-3"
          }, [
            _createElementVNode("use", { "xlink:href": "#close" })
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "inline-flex items-center",
          href: `mailto:?subject=${_ctx.title}&body=${encodeURIComponent(
            `${_ctx.text} (${_ctx.shareableLink})`
          )}`,
          target: "_blank",
          rel: "noopener"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            width: "38",
            height: "38",
            focusable: "false",
            "aria-hidden": "true",
            class: "mr-3"
          }, [
            _createElementVNode("use", { "xlink:href": "#email" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.shareEmailLabel), 1)
        ], 8, _hoisted_6),
        _createElementVNode("a", {
          class: "inline-flex items-center",
          href: `https://www.facebook.com/sharer.php?display=page&u=${_ctx.shareableLink}`,
          target: "_blank",
          rel: "noopener"
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("svg", {
            width: "38",
            height: "38",
            focusable: "false",
            "aria-hidden": "true",
            class: "mr-3"
          }, [
            _createElementVNode("use", { "xlink:href": "#facebook" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.shareFacebookLabel), 1)
        ], 8, _hoisted_7),
        _createElementVNode("button", {
          class: "inline-flex items-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.toggleShareModal();
            _ctx.copyTextRaw(_ctx.shareableLink, `${_ctx.linkCopyTitle}`);
          })
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("svg", {
            width: "38",
            height: "38",
            focusable: "false",
            "aria-hidden": "true",
            class: "mr-3"
          }, [
            _createElementVNode("use", { "xlink:href": "#copy" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.copyLinkLabel), 1)
        ])
      ])
    ])
  ]))
}